<template>
  <div>
    <header>
      <van-nav-bar
        :title="givenTitle"
      />
    </header>
    <main>
      <router-view/>
    </main>
    <footer>
    </footer>
  </div>
</template>

<script>

export default {
  data() {
    return {
      // givenTitle: window.location.hostname == 'prow.g.starpay.pe' ? 'WING KON' : 'CoriMall'
      givenTitle: 'CoriMall'
    }
  }
}
</script>

<style>
</style>